import { ApiFactory } from '@/api/api-factory';
import { DiscoveryNotification } from '@/lib/ui/notifier';
import UserGroupEntityAssignmentInput from '../lib/models/UserGroupEntityAssignmentInput';

const userGroupsClient = ApiFactory.getUserGroupsClient();

export default {
  async getUserGroups({ commit }, deploymentIndexId) {
    const userGroups = await userGroupsClient.getUserGroups(deploymentIndexId);
    commit('setIndexUserGroups', userGroups);
  },

  async getAssetUserGroups({ commit }, assetId) {
    const userGroups = await userGroupsClient.getAssetUserGroups(assetId);
    const assignmentInput = UserGroupEntityAssignmentInput.fromObject([assetId]);
    commit('setUserGroupEntityAssignmentInput', assignmentInput);
    commit('setAssetUserGroups', userGroups);
  },

  async assignUserGroupsToAsset({ commit, dispatch }, input) {
    try {
      commit('common/setShowBusyButtons', true, { root: true });
      await userGroupsClient.saveAssetAssignments(input);
      const notification = new DiscoveryNotification(
        'User Groups',
        'Asset assignments updated successflly.',
        null,
      );

      dispatch('common/addAppNotification', notification, { root: true });
      commit('common/setShowBusyButtons', false, { root: true });
    } catch (e) {
      console.error('error while assigning users to asset', e);
      commit('common/setShowBusyButtons', false, { root: true });
    }
  },
};
